import type Phaser from 'phaser';
import { gridFromBox, type Grid } from '../utils/grid';

// Field = весь canvas (W13). Никаких капов по min/max scene-size, никаких
// margin'ов сверху/снизу. Поле ВСЕГДА совпадает с окном Phaser.Scale.RESIZE.
// Адаптивная вёрстка достигается через fieldGrid (40×20): cellW/cellH = scene.w/h /
// (cols/rows). На любом экране — мобильном 600×360 или 4K 3840×2160 — игрок,
// враги, объекты позиционируются через grid-клетки, без хардкод'ов.

export interface SceneBox {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function getFieldWidth(scene: Phaser.Scene): number {
  return scene.scale.width;
}

export function getFieldTopY(_scene: Phaser.Scene): number {
  return 0;
}

export function getFieldBottomY(scene: Phaser.Scene): number {
  return scene.scale.height;
}

export function getFieldLeftX(_scene: Phaser.Scene): number {
  return 0;
}

export function getFieldRightX(scene: Phaser.Scene): number {
  return scene.scale.width;
}

export function getFieldMidX(scene: Phaser.Scene): number {
  return scene.scale.width / 2;
}

export function getFieldMidY(scene: Phaser.Scene): number {
  return scene.scale.height / 2;
}

export interface FieldBounds {
  top: number;
  bottom: number;
  left: number;
  right: number;
  midX: number;
  midY: number;
  width: number;
  height: number;
}

export function getFieldBounds(scene: Phaser.Scene): FieldBounds {
  const width = scene.scale.width;
  const height = scene.scale.height;
  return {
    top: 0,
    bottom: height,
    left: 0,
    right: width,
    midX: width / 2,
    midY: height / 2,
    width,
    height,
  };
}

// SceneBox-форма field — совместима с gridFromBox. Использовать когда нужно
// натянуть сетку на field (например, поделить поле на лейны для спавна или
// зоны боссфайта).
export function getFieldBox(scene: Phaser.Scene): SceneBox {
  return {
    left: 0,
    top: 0,
    width: scene.scale.width,
    height: scene.scale.height,
  };
}

// Grid поверх field (= весь canvas). Дефолт 40×20. На любом экране cellW =
// scene.w/40, cellH = scene.h/20. Все границы движения и зоны спавна
// выражаются через целые номера клеток — никаких пиксельных хардкод'ов.
// История: 40×10 → 40×20 (W13 — игроку нужно ходить почти до низа поля
// близко к слотам, мелкая сетка по Y даёт более тонкий контроль буферов).
export function fieldGrid(scene: Phaser.Scene, cols = 40, rows = 20): Grid {
  return gridFromBox(getFieldBox(scene), cols, rows);
}

// Y-границы движения врагов = совпадают с Y-границами спавна (cell 2..15 из 20).
// Совместимость с зоной стрельбы: игрок клампится в cell 4..18, отсюда стрельба
// хорошо покрывает ряды 2..15. Раньше поведения использовали getFieldTopY/Bottom
// (весь canvas 0..height) — враги дрейфовали в 0..1 ряд (за верхним HUD) и в
// 16..19 ряды (под слотами оружия), игрок не мог их достать.
// getFieldTopY/BottomY оставлены как есть — их используют боссы (charge wall-
// impact, spawn центрирование) и легитимно нуждаются в полных границах canvas.
export function getEnemyMovementTopY(scene: Phaser.Scene): number {
  return fieldGrid(scene).cell(0, 2).y;
}

export function getEnemyMovementBottomY(scene: Phaser.Scene): number {
  return fieldGrid(scene).cell(0, 15).bottom;
}
